import { Component, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { uiHelper } from '~/helpers/ui.helper';

declare let $;
import { translatePipe, translationHelper } from '~/helpers/translation.helper';
import { TournamentsService } from '~/legacy/ts/tournaments/services/tournaments.service';
import { Subscription } from 'rxjs';
import { CoreService } from '~/legacy/ts/services/core.service';

declare let SIR: any;

@Component({
    selector: 'comp_qr_modal',
    templateUrl: './qr-modal.html',
})
export class QrModal implements OnInit, OnDestroy {
    qrCode = '1';
    qrInterval;
    errorMessages = '';
    qrCodeSubscription: Subscription;

    constructor(
        private domSanitizer: DomSanitizer,
        private _uiHelper: uiHelper,
        public translate: translationHelper,
        public tournamentsService: TournamentsService,
        public coreService: CoreService,
    ) {
        this.qrCodeSubscription = this._uiHelper.qrCodeListener.subscribe(x => {
            if (x != 0) {
                this.qrCode = x;
                let thiss = this;

                // 5 saniyede bir kullanıcı giriş yaptı mı diye sorgu at
                this.qrInterval = setInterval(function() {
                    thiss.procBranchQrControlResult();
                }, 2500);

                // 300 saniye sonra temizle
                setTimeout(function() {
                    thiss.modalHide();
                }, 300000);
            }
        });
    }

    ngOnInit() {}

    ngAfterViewInit() {}

    modalHide() {
        clearInterval(this.qrInterval);
        $('#QR_Modal').modal('hide');
    }

    ngOnDestroy(): void {
        this.qrCodeSubscription.unsubscribe();
        clearInterval(this.qrInterval);
    }

    public procBranchQrControlResult() {
        this.errorMessages = '';
        this.tournamentsService.procBranchQrControlResult().then((result: any) => {
            if (result.ResultCode > 0) {
                // KART takma işlemleri result.Code

                const CustomerIdString = result.Code.toString();
                console.log('CustomerIdString', CustomerIdString);
                this.coreService.customerUser.QrCustomerId = CustomerIdString;
                this._uiHelper.SetCustomerQrStatus(true);
                // console.log('#--QR--#', CustomerIdString);
                // this.coreService.CustomerCardBalance(CustomerIdString);

                window.postMessage({ command: 'cardinserted', message: CustomerIdString }, '*');
                this.modalHide();
                return;
            }
            if (result.Code === '-1') {
                this.errorMessages = result.ResultMessage;
                return;
            }
        });
    }
}
